import React from "react";
import { SessionReview } from "./popups/SessionReview";


export function StudentSessionReviewContainer(props: any){
    return <SessionReview />
}
